const React = require("react");
require("./src/sass/style.scss");

exports.wrapPageElement = ({ element }) => {
  return <>{element}</>;
};
